import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1210px;
  margin: 0 auto;
  padding: 30px;
  min-width: 0;

  @media (max-width: 640px) {
    padding: 16px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  overflow-x: clip;
`;

export const MainBlock = styled.div<{ $isMap?: boolean }>`
  display: flex;
  gap: 24px;
  width: 100%;
  min-width: 0;

  ${({ $isMap }) =>
    $isMap &&
    `
    height: calc(100vh - 220px);
    overflow: hidden;
    align-items: stretch;
    gap: 8px;
  `}

  @media (max-width: 1280px) {
    padding-bottom: 88px;
    height: auto;
    overflow: visible;

    ${({ $isMap }) =>
      $isMap &&
      `
      padding-bottom: 0;
      height: calc(100dvh - 300px);
      overflow: hidden;
    `}
  }
`;

export const LoaderBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  width: 100%;
  padding: 90px 0;
`;

export const ContentWrapper = styled.div<{ $isMap?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 460px;
  min-width: 0;

  ${({ $isMap }) =>
    $isMap &&
    `
    height: 100%;
    min-height: 0;
    gap: 0;
  `}

  @media (max-width: 1280px) {
    max-width: 100%;
  }
`;
